import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { baseAdministrationEffects, baseAdministrationReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('administration', baseAdministrationReducer.baseAdministrationReducer),
    EffectsModule.forFeature([baseAdministrationEffects.BaseAdministrationEffects]),
  ],
})
export class BaseAdministrationStoreModule {}
